export default function isClientGranted(state, grant) {
  const { auth, lists, paths, client } = state

  const clientUserGrants = lists[`client_user_grants/${auth.uid}`]
  const isAdmin = paths[`admins/${auth.uid}`]
  const clientId = client.uid

  if (auth.isAuthorised !== true) {
    return false
  }

  if (isAdmin === true) {
    return true
  }

  if (clientUserGrants !== undefined) {
    // eslint-disable-next-line
    for (let clientGrants of clientUserGrants) {
      if (clientGrants !== undefined) {
        if (clientGrants.key === clientId) {
          return clientGrants.val.hasOwnProperty(grant)
        }
      }
    }
  }

  return false
}

export function isAnyClientGranted(state, grants) {
  if (grants !== undefined) {
    // eslint-disable-next-line
    for (let grant of grants) {
      if (isClientGranted(state, grant) === true) {
        return true
      }
    }
  }

  return false
}
